import Flags from '@ui/Flags/component'
import tooltipV2 from '@ui/Tooltip/component'
import { isMobile } from 'assets/core/js/common'

type OnOpenLinkListener = (card: HTMLElement) => void
interface Options {
  onOpenLink?: (card: HTMLElement) => void
}

const preventOpenClasses = [] as string[]

function openLink(url: string | null, card: HTMLElement, onOpenLink: OnOpenLinkListener | null): void {
  if (url) {
    if (!isMobile()) {
      window.open(url)
    } else {
      document.location.href = url
    }
    if (onOpenLink !== null) {
      onOpenLink(card)
    }
  }
}

function initializeOpenLink(card: HTMLElement, onOpenLink: OnOpenLinkListener | null): void {
  card.addEventListener('click', function (this: HTMLElement, e) {
    const target = e.target as HTMLElement

    if (preventOpenClasses.filter((val) => target.classList.contains(val) || target.closest(`.${val}`) !== null).length === 0) {
      e.preventDefault()
      e.stopPropagation()

      const link = card.querySelector<HTMLLinkElement>('.link')

      if (!link) {
        return
      }

      openLink(link.href, card, onOpenLink)
    }
  })
}

function initTooltips(rootEl: HTMLElement): void {
  const awardEl = rootEl.querySelector<HTMLElement>('.award')
  const awardTooltipEl = rootEl.querySelector<HTMLElement>('.award-tooltip')

  if (awardEl && awardTooltipEl) {
    tooltipV2(awardEl, awardTooltipEl)
  }

  Flags(rootEl)
}

export default function (el: HTMLElement, options: Options = {}): void {
  if (el.hasAttribute('data-init')) {
    return
  }

  initializeOpenLink(el, options.onOpenLink || null)
  initTooltips(el)

  el.setAttribute('data-init', 'true')
}
